import { Modal as GlueModal, withModalFn } from '@tencent/glue-react-ui';
import { withRefAdpCombine, ADP_COMBINE_PREFIX } from '../../config/context/config';
var AdpModal = withRefAdpCombine(GlueModal);
export var Modal = Object.assign(AdpModal, {
  alert: withModalFn({
    type: 'alert',
    prefix: ADP_COMBINE_PREFIX
  }),
  confirm: withModalFn({
    type: 'confirm',
    prefix: ADP_COMBINE_PREFIX
  })
});